import React from 'react';
import {useTranslation} from 'react-i18next';

import {ConfirmationModal} from '@pexip/components';

import {TestId} from '../../../test/testIds';

export const BreakoutRoomsGoBackToOpenedRoomsModal: React.FC<{
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}> = ({isOpen, onConfirm, onCancel}) => {
    const {t} = useTranslation();

    return (
        <ConfirmationModal
            isOpen={isOpen}
            title={t(
                'breakouts.go-back-to-opened-rooms-title',
                'Discard changes?',
            )}
            uniqueTitle={t(
                'breakouts.go-back-to-opened-rooms-title',
                'Discard changes?',
            )}
            data-testid={TestId.ModalBreakoutRoomsGoBackToOpenedRooms}
            description={t(
                'breakouts.go-back-to-opened-rooms-description',
                'You will lose the changes you made to the rooms.',
            )}
            confirmButtonText={t('common.ok', 'Ok')}
            confirmButtonTestid={
                TestId.ButtonBreakoutRoomsConfirmGoBackToOpenedRooms
            }
            cancelButtonText={t('common.cancel', 'Cancel')}
            cancelButtonTestid={
                TestId.ButtonBreakoutRoomsCancelGoBackToOpenedRooms
            }
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );
};
